import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import './styles/ConfirmationPopUp.scss';
import { Trans, useTranslation } from 'react-i18next'

interface Props {
  title: string,
  description: string,
  show: boolean,
  handleModalClose: () => void,
  saveBtnText: string,
  handleSuccess: () => void,
  note?: string
}

export const ConfirmationPopUp = (props: Props) => {
  const { t } = useTranslation()
  const { title, description, show, handleModalClose, saveBtnText, handleSuccess, note } = props

  return <Modal show={show} onHide={handleModalClose}>
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body><p>{description}</p>
      {note && <span className='note'><span className='note-heading'>Note: </span><Trans i18nKey={"sampleBarcode.modal.note"}></Trans></span>}</Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={handleModalClose}>
        No
      </Button>
      <Button variant="primary" onClick={handleSuccess}>
        {saveBtnText}
      </Button>
    </Modal.Footer>
  </Modal>
}